const sanitizeHTML = (dirtyText) => {
  if (typeof window !== 'undefined') {
    const doc = new DOMParser().parseFromString(dirtyText, 'text/html');
    return doc.body.innerHTML || ''; // Agora mantém as tags HTML
  }
  return dirtyText;
};

export function htmlToCleanParagraph(html) {
  let cleaned = html.replace(
    /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu,
    '',
  );

  cleaned = cleaned.replace(/<\/?[^>]+>/g, '\n');

  cleaned = cleaned
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .join('\n');

  return `<p>${cleaned}</p>`;
}

const decodeEntities = (encodedText) => {
  if (typeof window !== 'undefined') {
    const txt = document.createElement('textarea');
    txt.innerHTML = encodedText;
    return txt.value;
  }
  return encodedText;
};

export const sanitizeAndDecode = (dirtyText) => {
  const sanitizedText = sanitizeHTML(dirtyText);
  const decodedText = decodeEntities(sanitizedText);

  return decodedText
    .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
    .replace(/<li>(.*?)<\/li>/g, '<li>• $1</li>');
};
